<p-dialog
  [header]="header"
  [modal]="true"
  [visible]="visible"
  [style]="{
    width: '60vw',
    height: '75vh',
    display: 'flex',
    'flex-direction': 'column',
  }"
  [contentStyle]="{
    display: 'flex',
    'flex-direction': 'column',
    flex: '1 1 auto',
    'min-height': '0',
    overflow: 'hidden',
  }"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [closable]="true"
  (visibleChange)="onVisibleChange($event)"
>
  <div class="flex-1 min-h-0 overflow-y-auto">
    @if (notice) {
      <p-message severity="warn" [text]="notice" styleClass="mb-3 w-full" />
    }

    @if (showCustomTreeProposal && customTreeProposal; as proposal) {
      <div
        class="mb-4 rounded-md border border-surface-switch-200 bg-surface-switch-50 p-3"
        data-testid="custom-tree-proposal"
      >
        <div class="mb-2 flex flex-wrap items-center gap-2 text-sm font-medium">
          <i class="pi pi-sparkles text-primary" aria-hidden="true"></i>
          <span>AI-suggested draft structure</span>
          <span
            class="inline-flex items-center gap-1 rounded-full bg-surface-switch-100 px-2 py-0.5 text-xs font-medium"
          >
            AI draft
          </span>
          <span class="text-xs font-medium text-green-500">
            {{ suggestionPercent(proposal.confidence) }}
          </span>
        </div>
        <p class="m-0 text-sm font-semibold">{{ proposal.rootName }}</p>
        <p class="m-0 mt-1 text-sm text-muted-color">
          {{ proposal.structureSummary }}
          · {{ proposal.nodeCount }}
          {{ proposal.nodeCount === 1 ? "item" : "items" }}
        </p>
        @if (proposal.reason) {
          <p class="m-0 mt-2 text-sm text-muted-color">{{ proposal.reason }}</p>
        }
        <div class="mt-3">
          <p-button
            label="Use AI draft structure"
            icon="pi pi-sitemap"
            (onClick)="onConfirmCustomTree()"
          />
        </div>
      </div>
    }

    <app-blueprints-selector
      [selectedBlueprintId]="selectedBlueprint?.id || null"
      [blueprints]="blueprints"
      [nameSuggestions]="nameSuggestions"
      (blueprintSelected)="onBlueprintSelected($event)"
    ></app-blueprints-selector>
  </div>

  <ng-template #footer>
    <div class="flex items-center justify-between w-full gap-2">
      <p class="text-sm text-muted-color truncate">
        @if (showSkip && showCustomTreeProposal && aiSuggestionPreselected) {
          Compare the AI draft above with the pre-selected blueprint.
        } @else if (showSkip && aiSuggestionPreselected) {
          AI-suggested blueprint pre-selected. Change it or skip.
        } @else if (showSkip && showCustomTreeProposal) {
          AI draft available above, or choose a blueprint / skip.
        } @else if (selectedBlueprint) {
          Selected: {{ selectedBlueprint.name }}
        } @else if (showSkip) {
          {{ skipHint }}
        }
      </p>
      <div class="flex gap-2">
        <p-button label="Cancel" severity="secondary" (onClick)="onCancel()" />
        @if (showSkip) {
          <p-button
            label="Skip"
            severity="secondary"
            icon="pi pi-arrow-right"
            iconPos="right"
            (onClick)="onSkip()"
            [pTooltip]="skipTooltip"
            tooltipPosition="top"
          />
        }
        <p-button
          [label]="confirmLabel"
          icon="pi pi-check"
          (onClick)="onConfirm()"
          [disabled]="!selectedBlueprint"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
